import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Login from 'containers/Auth/Login'
import Register from 'containers/Auth/Register'
import ResetPassword from 'containers/Auth/ResetPassword'
import ConfirmPassword from 'containers/Auth/ConfirmPassword'
import GetStarted from 'containers/GetStarted'
import Dashboard from 'containers/Dashboard'
import Application from 'containers/Application'
import Settings from 'containers/Settings'
import Wallet from 'containers/Wallet'

import './assets/styles/main.css'
import './assets/styles/font.css'

function App() {
    return (
        <Switch>
            <Route path='/settings/:section' component={Settings} />
            <Route path='/get-started' component={GetStarted} />
            <Route path='/dashboard' component={Dashboard} />
            <Route path='/wallet' component={Wallet} />
            <Route path='/' exact>
                <Redirect to='/dashboard' />
            </Route>
            <Route path='/applications' exact component={Application} />
            <Route exact path='/login' component={Login} />
            <Route exact path='/register' component={Register} />
            <Route exact path='/reset-password' component={ResetPassword} />
            <Route exact path='/confirm-password' component={ConfirmPassword} />
        </Switch>
    )
}

export default App
